import React, { useState } from "react";
import images from "../../../constant/images";
import { Nav } from "../../../layouts/navbar/nav";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { useTranslation } from "react-i18next";

export default function ChangePass() {
  const baseUrl = useSelector((state) => state.gtm.baseUrl);

   const { i18n, t } = useTranslation();
    const changeLanguage = (lng) => {
      i18n.changeLanguage(lng);
    };
    const language = localStorage.getItem("i18nextLng");
  

  const [newPassword, setNewPassword] = useState("");
  const [passwordConfirmation, setPasswordConfirmation] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();
    const location = useLocation();
  
    const { source , email } = location.state;

  // Update the user password
  const forgotPass = async (e) => {
    e.preventDefault();

    try {
      setIsLoading(true);
      const response = await axios.post(`${baseUrl}/forgot-password`, {
        email : email,
        new_password: newPassword,
        new_password_confirmation: passwordConfirmation,
      },{
        withCredentials: true,
        withXSRFToken: true,
        credentials: "include",
      });

      if (response.status === 200) {
        setError("");
        setMessage(response.data.message);
        setTimeout(() => {
          navigate("/login");
        }, 2000);
      }
    } catch (error) {
      setError(
        error.response?.data?.message || "An unexpected error occurred."
      );
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div
      className="flex flex-col gap-12"
      style={{
        backgroundImage: `url(${images.golf_field})`,
        backgroundPosition: "center",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        position: "relative",
        height:"100vh"
      }}
    >
      <div>
        <Nav/>
      </div>

      {/* Change Password Container */}
      <div className="flex items-center justify-center w-full mb-8">
        <div className="shadow-[0px_6px_20px_rgba(0,0,0,0.7)] bg-white p-4 md:p-12 rounded-xl w-full max-w-[80%] sm:max-w-[620px] text-center mt-0 md:mt-2.5">
          {/* Title */}
          <h3 className="text-2xl sm:text-3xl mb-6 sm:mb-8 text-center font-semibold text-black mx-auto">
          {t("forgot.change_password")}

          </h3>

          {/* Change Password Form */}
          <form className="space-y-4" onSubmit={forgotPass}>
            {/* New Password Field */}
            <input
              type="password"
              name="newPassword"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              className="bg-[#F4F5F9] border-none rounded-xl py-3 px-5 mb-3.5 w-full max-w-full sm:max-w-[500px] mx-auto block placeholder-[#A4A4A4]"
              placeholder=          {t("forgot.new_password")}

              required
            />
            {/* Confirm Password Field */}
            <input
              type="password"
              name="passwordConfirmation"
              value={passwordConfirmation}
              onChange={(e) => setPasswordConfirmation(e.target.value)}
              className="bg-[#F4F5F9] border-none rounded-xl py-3 px-5 mb-3.5 w-full max-w-full sm:max-w-[500px] mx-auto block placeholder-[#A4A4A4]"
              placeholder={t("forgot.confirm_password")}
              required
            />
            {/* Submit Button */}
            <button
              type="submit"
              className="w-full sm:max-w-[350px] py-3 text-base rounded-[33px] bg-black font-semibold border-none cursor-pointer mx-auto block hover:bg-[#333] text-white"
              disabled={isLoading}
              onClick={forgotPass}
            >
              {isLoading ? "Updating..." : `${t("forgot.update_password")}`}
            </button>
          </form>

          {/* Display Messages */}
          {message && <p className="text-green-500 mt-4">{message}</p>}
          {error && <p className="text-red-500 mt-4">{error}</p>}
        </div>
      </div>
    </div>
  );
}
